module.exports = __webpack_public_path__ + "img/H29-spain.423b6f44.png";